import React, { FC } from 'react';
import { FormNumberField } from '@components/common/FormNumberField/FormNumberField';
import { InputAdornment } from '@components/common/InputAdornment';
import { IFormCurrencyFieldProps } from './types';

export const FormCurrencyField: FC<IFormCurrencyFieldProps> = React.forwardRef(
  (
    { textFieldProps, name, rules, numericFormatProps, defaultValue = '', className, shouldShowAdornment = false },
    ref,
  ) => {
    return (
      <FormNumberField
        defaultValue={defaultValue}
        name={name}
        rules={rules}
        numericFormatProps={{
          decimalScale: 2,
          fixedDecimalScale: true,
          allowNegative: false,
          ...numericFormatProps,
        }}
        className={className}
        shouldShowAdornment={shouldShowAdornment}
        textFieldProps={{
          ...textFieldProps,
          size: 'small',
          InputProps: {
            ref,
            startAdornment: <InputAdornment position={'start'}>£</InputAdornment>,
            placeholder: textFieldProps?.placeholder,
            endAdornment: textFieldProps?.InputProps?.endAdornment,
          },
          suffix: textFieldProps?.suffix,
        }}
      />
    );
  },
);

FormCurrencyField.displayName = 'FormCurrencyField';
